<template>
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-mt-2">
                <DataTable :value="callSettingsList" :lazy="true" :paginator="true" :rows="30"
                    :totalRecords="totalRecords" :loading="loading" @page="onPage($event)" class="p-datatable-users"
                    dataKey="mbz1" :rowHover="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
                    <Toolbar>
                        <template v-slot:left>
                            <h5 class="p-m-0">Call Settings</h5>
                        </template>
                        <template v-slot:right>
                            <Button label="Add Call Settings" icon="pi pi-plus" @click="toAddcallSettings" />
                            <Button label="Filter" icon="pi pi-filter" @click="filterlisting()" class="p-mr-2"
                                style="margin-left: 0.5rem; "></Button>
                        </template>
                    </Toolbar>
                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait... </template>
                    <Column headerStyle="width: 2%" class="align-center"></Column>
                    <Column field="id" header="Sr." headerStyle="width: 10%">
                        <template #body="{ index }">
                            <div>{{ genrateSrNo(index) }}</div>
                        </template>
                    </Column>
                    <Column header="DID Number" field="cb3" class="p-text-capitalize" headerStyle="width: 25%">
                    </Column>
                    <Column header="Day Time" field="cb5" class="p-text-capitalize" headerStyle="width: 25%">
                        <template #body="{ data: { cb5 } }">
                            <div>
                                <span v-if="cb5 != '' && cb5 != null && cb5 != '0'">
                                    <span v-for="(value, index) in cb5.split(',')" :key="index">
                                        <Chip class="p-mr-1 p-mb-1 custom-multi-chip-hosts" :label="value" />
                                    </span>
                                </span>
                                <span v-else>-</span>
                            </div>
                        </template>
                    </Column>
                    <Column header="Client Name" field="cb9" class="p-text-capitalize" headerStyle="width: 25%">
                    </Column>
                    <Column header="Status" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <span v-if="data.cb25 == 1" :class="'user-badge status-active'">Active</span>
                            <span v-if="data.cb25 == 0" :class="'user-badge status-temp-suspend'">Inactive</span>
                        </template>
                    </Column>
                    <Column header="Action" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2"
                                @click="editCallSettings(data)" />
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
    <!-- Add call settings Dialog starts here -->
    <Dialog v-model:visible="isAddCallSetting" :style="{ width: '900px' }" :modal="true" class="p-fluid"
        header="Add Call Settings">
        <div style="position: relative" v-if="!showLoader">
            <div class="p-pt-2 p-px-3">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-4">
                        <label for="clientname">Client Name <span class="p-invalid p-error">*</span></label>
                        <Dropdown id="clientname" v-model="clientname" :options="clientnameList" optionLabel="label"
                            placeholder="Select client name" appendTo="body">
                        </Dropdown>
                        <small class="p-invalid p-error" v-if="v$.clientname.$error">{{
                            v$.clientname.$errors[0].$message
                            }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-4">
                        <label for="didNumber">DID Number <span class="p-invalid p-error">*</span></label>
                        <Dropdown id="didNumber" v-model="didNumber" :options="didNumberList" optionLabel="label"
                            placeholder="Select DID Number" appendTo="body"></Dropdown>
                        <small class="p-invalid p-error" v-if="v$.didNumber.$error">{{ v$.didNumber.$errors[0].$message
                        }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-4">
                        <label for="selectedDay">Day <span class="p-invalid p-error">*</span></label>
                
                        <MultiSelect v-model="selectedDay" :options="selectedDayList" :searchable="true"
                            optionLabel="label" placeholder="Select Day" class="multiselect-custom text-capitalize"
                            :canClear="true" appendTo="body" :closeOnSelect="true" :object="true" mode="tags" 
                             />
                        <small class="p-invalid p-error" v-if="v$.selectedDay.$error">{{
                            v$.selectedDay.$errors[0].$message
                            }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-4">
                        <label for="starttime">Start Time <span class="p-invalid p-error">*</span></label>
                        <Dropdown id="starttime" v-model="startsettime" :options="timeList" optionLabel="label"
                            placeholder="Start Time" appendTo="body" :canClear="false" :closeOnSelect="true"
                            @change="endsettime = null" />
                        <small class="p-invalid p-error" v-if="v$.startsettime.$error">{{
                            v$.startsettime.$errors[0].$message
                            }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-4">
                        <label for="employee">End time <span class="p-invalid p-error">*</span></label>
                        <Dropdown v-model="endsettime" :options="filteredTimeList(startsettime)" optionLabel="label"
                            placeholder="End Time" :canClear="false" appendTo="body" :closeOnSelect="true"
                            :object="true" :disabled="!startsettime" @select="checkValidation()" />
                        <small class="p-invalid p-error" v-if="v$.endsettime.$error">{{
                            v$.endsettime.$errors[0].$message
                            }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-4">
                        <label for="employee">Employee <span class="p-invalid p-error">*</span></label>
                        <MultiSelect v-model="customerCareEmployees" :options="numbersettingset" :searchable="true"
                            optionLabel="label" placeholder="Select Users" class="multiselect-custom text-capitalize"
                            :canClear="true" appendTo="body" :closeOnSelect="true" :object="true" mode="tags" style=""
                            :max="8" />
                        <small class="p-invalid p-error" v-if="v$.customerCareEmployees.$error">{{
                            v$.customerCareEmployees.$errors[0].$message
                            }}</small>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Submit" :icon="`pi ${!showLoaderAddBtn ? 'pi-check' : 'pi-spin pi-spinner indigo-color'}`"
                class="p-button-text p-ml-auto" @click="addCallSettings" style="width: 90px;"></Button>
        </template>
    </Dialog>
    <!-- Add Role Dialog ends here -->

    <!-- Edit Role Dialog starts here -->
    <Dialog v-model:visible="isEditCallSetting" header="Edit Call Settings" :style="{ width: '900px' }" :modal="true"
        class="p-fluid">
        <div style="position: relative" v-if="!showLoader">
            <div class="p-pt-2 p-px-3">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-4">
                        <label for="clientname">Client Name <span class="p-invalid p-error">*</span></label>
                        <Dropdown id="clientname" v-model="clientname" :options="clientnameList" optionLabel="label"
                            placeholder="Select client name" appendTo="body"
                            >
                        </Dropdown>
                        <small class="p-invalid p-error" v-if="v$.clientname.$error">{{
                            v$.clientname.$errors[0].$message
                            }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-4">
                        <label for="didNumber">DID Number <span class="p-invalid p-error">*</span></label>
                        <Dropdown id="didNumber" v-model="didNumber" :options="didNumberList" optionLabel="label"
                            placeholder="Select DID Number" appendTo="body" :disabled="!clientname"></Dropdown>
                        <small class="p-invalid p-error" v-if="v$.didNumber.$error">{{ v$.didNumber.$errors[0].$message
                        }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-4">
                        <label for="selectedDay">Day <span class="p-invalid p-error">*</span></label>
                        <!-- <Dropdown id="selectedDay" v-model="selectedDay" :options="selectedDayList" optionLabel="label"
                            placeholder="Select Day" appendTo="body"></Dropdown> -->
                        <MultiSelect v-model="selectedDay" :options="selectedDayList" :searchable="true"
                            optionLabel="label" placeholder="Select Day" class="multiselect-custom text-capitalize"
                            :canClear="true" appendTo="body" :closeOnSelect="true" :object="true" mode="tags" style=""
                            />
                        <small class="p-invalid p-error" v-if="v$.selectedDay.$error">{{
                            v$.selectedDay.$errors[0].$message
                            }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-4">
                        <label for="starttime">Start Time <span class="p-invalid p-error">*</span></label>
                        <Dropdown id="starttime" v-model="startsettime" :options="timeList" optionLabel="label"
                            placeholder="Start Time" appendTo="body" :canClear="false" :closeOnSelect="true"
                            @change="endsettime = null" />
                        <small class="p-invalid p-error" v-if="v$.startsettime.$error">{{
                            v$.startsettime.$errors[0].$message
                            }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-4">
                        <label for="employee">End time <span class="p-invalid p-error">*</span></label>
                        <Dropdown v-model="endsettime" :options="filteredTimeList(startsettime)" optionLabel="label"
                            placeholder="End Time" :canClear="false" appendTo="body" :closeOnSelect="true"
                            :object="true" :disabled="!startsettime" @select="checkValidation()" />
                        <small class="p-invalid p-error" v-if="v$.endsettime.$error">{{
                            v$.endsettime.$errors[0].$message
                            }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-4">
                        <label>Status</label>
                        <Dropdown id="adminstatus" v-model="adminstatus" :disabled="!isEditCallSetting"
                            :options="adminstatusList" optionLabel="label" placeholder="Select ..." appendTo="body">
                        </Dropdown>
                    </div>
                    <div class="p-field p-col-12 p-md-8">
                        <label for="employee">Employee <span class="p-invalid p-error">*</span></label>
                        <MultiSelect v-model="customerCareEmployees" :options="numbersettingset" :searchable="true"
                            optionLabel="label" placeholder="Select Users" class="multiselect-custom text-capitalize"
                            :canClear="true" appendTo="body" :closeOnSelect="true" :object="true" mode="tags" style=""
                            :max="8" />
                        <small class="p-invalid p-error" v-if="v$.customerCareEmployees.$error">{{
                            v$.customerCareEmployees.$errors[0].$message
                            }}</small>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Submit" :icon="`pi ${!showLoaderAddBtn ? 'pi-check' : 'pi-spin pi-spinner indigo-color'}`"
                class="p-button-text p-ml-auto" @click="editCitys(rowData)" style="width: 90px;"></Button>
        </template>
    </Dialog>

    <!-- Filter dialog start here -->
    <Dialog v-model:visible="isFilter" :style="{ width: '600px' }" header="City Filter" :modal="true" class="p-fluid">
        <div class="p-pt-2 p-px-3">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-6">
                    <label for="filterselectedDay"> Day</label>
                    <Dropdown id="filterselectedDay" v-model="filterSelectedDay" :options="selectedDayList"
                        optionLabel="label" placeholder="Select Day" appendTo="body" ></Dropdown>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label>Status</label>
                    <Dropdown id="adminstatus" v-model="adminstatus" :options="adminstatusList" optionLabel="label"
                        placeholder="Select ..." appendTo="body">
                    </Dropdown>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Reset" icon="pi pi-refresh" class="p-button-text" @click="reSetFilteredData()" />
            <Button label="Search" icon="pi pi-search" class="p-mr-2" autofocus @click="submitFilter" />
        </template>
    </Dialog>
    <!-- Filter dialog end here -->
</template>

<script>
import ApiService from '../../service/ApiService';
import useValidate from '@vuelidate/core';
import { useConfirm } from "primevue/useconfirm";
import { required, helpers } from '@vuelidate/validators';

export default {
    data() {
        return {
            confirm: useConfirm(),
            callSettingsList: [],
            v$: useValidate(),
            isAddCallSetting: false,
            isSubmitted: false,
            showLoader: false,
            loading: false,
            page_no: 0,
            totalRecords: 0,
            isEditCallSetting: false,
            showLoaderAddBtn: false,
            rowId: '',
            reportreason: '',
            countries: [],
            clientname: '',
            country: '',
            clientnameList: [],
            adminstatus: { label: 'Active', value: 1 },
            adminstatusList: [
                { label: 'Active', value: 1 },
                { label: 'Inactive', value: 0 },
            ],
            isFilter: false,
            filterSelectedDay: '',
            startsettime: '',
            endsettime: '',
            selectedDay: [],
            customerCareEmployees: '',
            numbersettingset: [],
            selectedDayList: [],
            didNumber: '',
            didNumberList: [],
            selectedEmployee: '',
            selectedEmployeeList: [],
            timeList: [
                { value: 1, label: "00:00:00" },
                { value: 2, label: "00:30:00" },
                { value: 3, label: "01:00:00" },
                { value: 4, label: "01:30:00" },
                { value: 5, label: "02:00:00" },
                { value: 6, label: "02:30:00" },
                { value: 7, label: "03:00:00" },
                { value: 8, label: "03:30:00" },
                { value: 9, label: "04:00:00" },
                { value: 10, label: "04:30:00" },
                { value: 11, label: "05:00:00" },
                { value: 12, label: "05:30:00" },
                { value: 13, label: "06:00:00" },
                { value: 14, label: "06:30:00" },
                { value: 15, label: "07:00:00" },
                { value: 16, label: "07:30:00" },
                { value: 17, label: "08:00:00" },
                { value: 18, label: "08:30:00" },
                { value: 19, label: "09:00:00" },
                { value: 20, label: "09:30:00" },
                { value: 21, label: "10:00:00" },
                { value: 22, label: "10:30:00" },
                { value: 23, label: "11:00:00" },
                { value: 24, label: "11:30:00" },
                { value: 25, label: "12:00:00" },
                { value: 26, label: "12:30:00" },
                { value: 27, label: "13:00:00" },
                { value: 28, label: "13:30:00" },
                { value: 29, label: "14:00:00" },
                { value: 30, label: "14:30:00" },
                { value: 31, label: "15:00:00" },
                { value: 32, label: "15:30:00" },
                { value: 33, label: "16:00:00" },
                { value: 34, label: "16:30:00" },
                { value: 35, label: "17:00:00" },
                { value: 36, label: "17:30:00" },
                { value: 37, label: "18:00:00" },
                { value: 38, label: "18:30:00" },
                { value: 39, label: "19:00:00" },
                { value: 40, label: "19:30:00" },
                { value: 41, label: "20:00:00" },
                { value: 42, label: "20:30:00" },
                { value: 43, label: "21:00:00" },
                { value: 44, label: "21:30:00" },
                { value: 45, label: "22:00:00" },
                { value: 46, label: "22:30:00" },
                { value: 47, label: "23:00:00" },
                { value: 48, label: "23:30:00" },
                { value: 49, label: "24:00:00" },
            ],
        };
    },
    validations() {
        return {
            customerCareEmployees: { required: helpers.withMessage('Please select user', required) },
            selectedDay: { required: helpers.withMessage('Please enter selected day', required) },
            adminstatus: { required: helpers.withMessage('Please select admin status', required) },
            clientname: { required: helpers.withMessage('Please select client name', required) },
            didNumber: { required: helpers.withMessage('Please select did number', required) },
            startsettime: { required: helpers.withMessage('Please select start time', required) },
            endsettime: { required: helpers.withMessage('Please select end time', required) },
        };
    },
    ApiService: null,
    created() {
        this.ApiService = new ApiService();
    },
    async mounted() {
        this.loading = true;
        this.getCallSettingList({ page_no: this.page_no });
        this.getAdminListOnly();
        this.getWeekDays();
        this.getSuperAdminUserListForAppSupport();
        // this.getDIDNumberByCLientId();

    },
    methods: {
        getAdminListOnly() {
            this.ApiService.getAdminListOnly().then((data) => {
                if (data.success === true) {
                    this.clientnameList = data.data.records;
                }
            });
        },
        getDIDNumberByCLientId(e) {
            this.ApiService.getDIDNumberByCLientId().then((data) => {
                if (data.success === true) {
                    let allDidNumbers = data.data;
                    const usedDidIds = this.callSettingsList.map(item => item.cb2); // cb2 = used DID numbers

                    // Exclude used DIDs if adding
                    if (this.isAddCallSetting) {
                        allDidNumbers = allDidNumbers.filter(did => !usedDidIds.includes(did.value));
                    }

                    // Exclude all used DIDs EXCEPT current row's DID if editing
                    if (this.isEditCallSetting) {
                        allDidNumbers = allDidNumbers.filter(did =>
                            !usedDidIds.includes(did.value) || did.value === this.currentDidValue
                        );
                    }

                    this.didNumberList = allDidNumbers;

                    // Set selected DID
                    if (e) {
                        this.didNumber = this.didNumberList.find(item => item.value == e) || '';
                    } else if (this.currentDidValue) {
                        this.didNumber = this.didNumberList.find(item => item.value == this.currentDidValue) || '';
                    } else {
                        this.didNumber = '';
                    }
                }
            });
        },
        getSuperAdminUserListForAppSupport() {
            this.ApiService.getSuperAdminUserListForAppSupport().then((data) => {
                if (data.success === true) {
                    this.numbersettingset = data.data;
                }
            });
        },
        getWeekDays() {
            this.ApiService.getWeekDays().then((data) => {
                if (data.success === true) {
                    this.selectedDayList = data.data;
                }
            });
        },
        getCallSettingList(e) {
            e.page_no = this.page_no;
            this.ApiService.getCallSettingList(e).then((items) => {
                if (items.status === 200) {
                    this.callSettingsList = items.data;
                    this.totalRecords = items.count;
                    this.isFilter = false;
                } else {
                    this.callSettingsList = [];
                }
                this.loading = false;
            });
        },
        async toAddcallSettings() {
            this.isAddCallSetting = true;
            this.getDIDNumberByCLientId();
            this.isSubmitted = false;
            this.clientname = '';
            this.didNumber = '';
            this.selectedDay = [];
            this.startsettime = '';
            this.endsettime = '';
            this.customerCareEmployees = [];
            this.v$.$reset();
        },
        addCallSettings() {
            this.submitted = true;
            this.errormsg = '';
            this.v$.$validate();
            let formData = new FormData();
            formData.append('cb2', this.didNumber?.value);
            formData.append('cb3', this.didNumber?.label);
            const selectedLabels = this.selectedDay?.map(day => day.label).join(',');
            const selectedValues = this.selectedDay?.map(day => day.value).join(',');
            formData.append('cb4', selectedValues);          
            formData.append('cb5', selectedLabels);
            formData.append('cb6', this.startsettime?.label);
            formData.append('cb7', this.endsettime?.label);
            formData.append('cb8', this.clientname?.value);
            formData.append('cb9', this.clientname?.label);
            const selectedUsers = this.customerCareEmployees.slice(0, 5);
            for (let i = 0; i < 5; i++) {
                const user = selectedUsers[i] || { value: '', label: '', mobile: '' };
                const baseIndex = 10 + i * 3;
                formData.append(`cb${baseIndex}`, user.value);
                formData.append(`cb${baseIndex + 1}`, user.label);
                formData.append(`cb${baseIndex + 2}`, user.mobile);
            }
            formData.append('cb25', 1);
            this.v$.$validate();
            if (!this.v$.$error) {
                this.showLoaderAddBtn = true;
                this.ApiService.insertOrUpdateCallSetting(formData).then((items) => {
                    if (items.status == 200) {
                        this.showLoaderAddBtn = false;
                        var successMsg = items.message;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        this.getCallSettingList({ page_no: this.page_no });
                        this.isAddCallSetting = false;
                        this.reportreason = '';
                    } else {
                        this.showLoaderAddBtn = false;
                        var errorMsg = items.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                });
            }
        },
        async editCallSettings(data) {
            this.isEditCallSetting = true;
            this.clientname = '';
            this.adminstatus = '',
            this.didNumber = '';
            this.startsettime = '';
            this.endsettime = '';
            this.customerCareEmployees = [];
            this.isSubmitted = false;
            this.rowId = data.cb1;
            this.clientname = this.clientnameList.find((item) => item.value == data.cb8);
            this.adminstatus = this.adminstatusList.find((item) => item.value == data.cb25);
            this.currentDidValue = data.cb2;
            await this.getDIDNumberByCLientId();
            this.selectedDay = this.selectedDayList.filter((item) => data.cb4?.includes(item.value));
            this.startsettime = this.timeList.find((item) => item.label == data.cb6);
            this.endsettime = this.timeList.find((item) => item.label == data.cb7);
            for (let i = 10; i <= 24; i += 3) {
                const id = data[`cb${i}`];
                const label = data[`cb${i + 1}`];
                const mobile = data[`cb${i + 2}`];

                if (id && label && mobile) {
                    this.customerCareEmployees.push({ value: id, label, mobile });
                }
            }
            this.v$.$reset();
        },
        editCitys() {
            this.submitted = true;
            this.errormsg = '';
            let formData = new FormData();
            formData.append('cb1', this.rowId);
            formData.append('cb2', this.didNumber?.value);
            formData.append('cb3', this.didNumber?.label);
            const selectedLabels = this.selectedDay?.map(day => day.label).join(',');
            const selectedValues = this.selectedDay?.map(day => day.value).join(',');
            formData.append('cb4', selectedValues);
            formData.append('cb5', selectedLabels);
            formData.append('cb6', this.startsettime?.label);
            formData.append('cb7', this.endsettime?.label);
            formData.append('cb8', this.clientname?.value);
            formData.append('cb9', this.clientname?.label);
            const selectedUsers = this.customerCareEmployees.slice(0, 5);
            for (let i = 0; i < 5; i++) {
                const user = selectedUsers[i] || { value: '', label: '', mobile: '' };
                const baseIndex = 10 + i * 3;
                formData.append(`cb${baseIndex}`, user.value);
                formData.append(`cb${baseIndex + 1}`, user.label);
                formData.append(`cb${baseIndex + 2}`, user.mobile);
            }
            formData.append('cb25', this.adminstatus.value);
            this.v$.$validate();
            if (!this.v$.$error) {
                this.showLoaderAddBtn = true;
                this.ApiService.insertOrUpdateCallSetting(formData).then((items) => {
                    if (items.status == 200) {
                        this.showLoaderAddBtn = false;
                        var successMsg = items.message;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        this.getCallSettingList({ page_no: this.page_no });
                        this.isEditCallSetting = false;
                        this.reportreason = '';
                    } else {
                        this.showLoaderAddBtn = false;
                        var errorMsg = items.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                });
            }
        },
        onPage(event) {
            this.loading = true;
            this.page_no = event.page;
            this.getCallSettingList({ page_no: event.page });
        },
        reSetFilteredData() {
            this.getCallSettingList({ page_no: this.page_no });
            this.isFilter = false;
            this.filterSelectedDay = '';
            this.adminstatus = { label: 'Active', value: 1 };
            this.showFillFilter = false;
        },
        filterlisting() {
            this.isFilter = true;
            this.adminstatus = { label: 'Active', value: 1 };
        },
        submitFilter() {
            this.showFillFilter = true;
            this.getCallSettingList({
                cb4: this.filterSelectedDay?.value, cb5: this.filterSelectedDay?.label,
                cb25: this.adminstatus.value
            });
        },
        filteredTimeList(startTime) {
            if (!startTime || !startTime.label) return [];
            const startIndex = this.timeList.findIndex(item => item.label === startTime.label);
            return this.timeList.filter((_, idx) => idx > startIndex);
        },
    }
};
</script>